import React from "react";
import Header from "../../common/header";

const IndianTaxis = () => {
  const data = {
    title: "Indian Taxis",
    subText:
      "We provide convenient mobility solutions to commuters at the best and lowest fares. ",
  };

  return (
    <div style={{ marginTop: "100px", fontSize: "20px" }}>
      <Header data={data} />

      <div
        className="container indiantaxis"
        style={{ marginTop: "120px", marginBottom: "100px" }}
      >
        <p>
          This intuitive and user friendly taxi app is focused on providing
          quick, hassle free and reliable mobility solutions to commuters. We
          provide cab services all over India 24*7 and 365 days of the year.
          Instant booking for outstation rides are also provided.{" "}
        </p>
        <h3>Some Issues Faced By Commuters With Other Cab Operators </h3>
        <div className="title-line-contact " />
        <ul>
          <li>
            The fare charged for each trip depends upon the time, ie during
            peak/nonpeak hours. Normally very high rates are charged from the
            customers during peak hours and rainy days.
          </li>
          <li>
            The customers without smartphones or the app not installed in their
            mobile phones cannot travel.{" "}
          </li>
          <li>
            Drivers aren't supposed to book the trip on behalf of the customers.
          </li>
          <li>High commissions are charged from the customers.</li>
          <li>Penalty is charged for cancellation of the booking. </li>
        </ul>
        <h3>How We Are Different </h3>
        <div className="title-line-contact " />
        <ul>
          <li>
            The fare charged from the customer is in accordance with the rates
            prescribed by the govt and does not vary during, peak hours.
          </li>
          <li>
            The customers without smartphones or the app not installed in their
            mobile phones can also hire a taxi online with us.
          </li>
          <li>Drivers can book the trips on behalf of the customers.</li>
          <li>No commissions are charged from the customers. </li>
          <li>No penalty is charged for cancellation of the booking. </li>
        </ul>
        <h3>Unique Features Of Indian Taxis </h3>
        <div className="title-line-contact " />
        <ul>
          <li>Easy and fast booking with VIP services available. </li>
          <li>
            SOS alert notification option for both customers and drivers in case
            of emergencies.{" "}
          </li>
          <li>
            Option to negotiate with the drivers for long trips as per the
            vehicle owner confirmation.{" "}
          </li>
          <li>Receive discounts directly from the drivers. </li>
          <li>Separate application for both drivers and commuters.</li>
          <li>Faster and easier registration process</li>
          <li>No surge prices or additional charges.</li>
          <li>
            Option to book trips as per requirements- Local, Rental or
            Outstation.{" "}
          </li>
          <li>Pocket friendly rates,ie fixed by the Govt.</li>
          <li>Safe and comfortable rides. </li>
          <li>Options to choose from different types of vehicles. </li>
          <li>
            Option to check the driver's location via GPS and fare for a
            particular trip.{" "}
          </li>
          <li>24*7 customer care support services. </li>
          <li>
            Advance booking option available for rental and outstation rides.{" "}
          </li>
          <li>Invoice of past rides available.</li>
          <li>
            Driver information and vehicle details sent to the customer before
            driver's arrival.{" "}
          </li>
          <li>Details of drivers available with the management. </li>
          <li>Reduced waiting time.</li>
          <li>Well disciplined and highly professional cab drivers. </li>
          <li>Provision of offers and discounts.</li>
        </ul>
        <h3>How Customers Benefit With Us</h3>
        <div className="title-line-contact " />
        <ul>
          <li>
            Customers can register into the application using their active
            mobile number and enjoy rides without paying any sort of
            commissions.{" "}
          </li>
          <li>
            Customers shall choose the destination they plan to travel from
            their current location.
          </li>
          <li>
            Customers may choose the vehicle model & price for the trip and
            confirm their booking with the cab.
          </li>
          <li>
            Customers are given the opportunity to share the ride details to
            their family/friends.
          </li>{" "}
          <li>
            Customers can plan in advance to ride outstation on Rental basis.{" "}
          </li>
          <li>
            Customers can share the application to their family or friends and
            get points for the same.{" "}
          </li>
          <li>
            The taxi fares do not fluctuate from time to time and it comes as an
            added advantage to the customers.{" "}
          </li>
        </ul>
        <h3>Why Choose Us</h3>
        <div className="title-line-contact " />
        <h5>Cabs For Every Occasion</h5>
        <p>
          We offer city taxis, inter city cabs and rental car services at
          affordable rates. Choose from a range of hatchbacks, SUV's, Sedans or
          luxury cabs to suit your unique travel needs.
        </p>{" "}
        <h5>Govt Approved Per Km Charges</h5>
        <p>
          Our taxi charges are reasonable and fixed as per the Govt approved per
          km rates.
        </p>
        <h5>Direct Payment</h5>
        <p>
          Customers shall pay directly to the drivers as per their convenience .
          No third party is involved.{" "}
        </p>
        <h5>Safe and Secure Rides</h5>
        <p>
          We strive to provide safe and comfortable rides for our commuters. You
          can also keep your loved ones informed or avail our SOS facility in
          case of an emergency. Our SOS option alerts the company and also the
          police control room.{" "}
        </p>
        <h5>No Surge Charges</h5>
        <p>
          We do not charge any sort of additional charges from our commuters.{" "}
        </p>
        <h5>Verified Drivers</h5>
        <p>
          All our driver-partners are background verified. We ensure you a safe,
          comfortable and enjoyable travel experience every time you ride with
          us.
        </p>
        <h5>24*7 Customer Care and On Road Services</h5>
        <p>
          We have a dedicated and friendly customer support team always at your
          service.
        </p>
        <h3>Our Specialities</h3>
        <div className="title-line-contact " />
        <h5>Taxi Services</h5>
        <p>
          Book your rides with us and enjoy quick, hassle free, safe and
          convenient cab services at the lowest fares. We provide you with cheap
          taxi booking and do not charge any commission on your rides. Highly
          recommended for your everyday travel needs. Our Ac cabs are available
          24*7 with options to book a taxi and travel instantly.
        </p>
        <h5>Rental Services</h5>
        <p>
          Avail our rental car services as per your convenience and get a cab at
          your disposal!{" "}
        </p>
        <ul>
          <li>
            Attend a full day business meeting, explore a new city, go shopping
            with family, outing with friends, airport rides or simply enjoy your
            weekend getaway! Yes, we got you covered!{" "}
          </li>
          <li>
            Rental packages start at one hour with options to extend upto 12
            hours. Cabs can also be retained beyond package limits with nominal
            charges.{" "}
          </li>
          <li>
            Hire a cab for as long as you need and travel to multiple locations
            within the city.{" "}
          </li>
          <li>
            Our flexible booking option allows you to book cabs instantly or
            upto 48 hours in advance.
          </li>
          <li>
            Safe and secure travel experience everytime you ride with us.{" "}
          </li>
        </ul>
        <h5>Outstation Rides</h5>
        <p>Planning for an outstation trip with a taxi in India? </p>
        <p>
          We provide advance taxi booking online services for all your one way
          and round trip outstation rides.{" "}
        </p>
        <ul>
          <li>
            Choose from a wide range of Ac cabs available in an hour or book
            upto 7 days in advance.
          </li>
          <li>
            Forget about paying the fare of return journey for your one way
            travels. Fares are fixed as per government approved rates.
          </li>
          <li>
            {" "}
            At Indian Taxis, your safety is our topmost priority. We assign high
            rated and verified driver partners to give you the best and smooth
            outstation travel experience.
          </li>
          <li>
            Avail our outstation services for business meetings, pilgrimages,
            family road trips, or even for weekend getaways.
          </li>
          <li>
            Choose from a range of hatchbacks, sedans, SUV's or even luxury cabs
            as per your preference.
          </li>
        </ul>
      </div>

      {/* <header className="bg-primary text-white  " style={{ height: "177px" }}>
        <div class="container text-center pt-5 ">
          <h1>Indian taxis</h1>
          <p>A landing page template freshly redesigned for Bootstrap 4</p>
        </div>
        <div class="container1">
          <svg
            viewBox="0 0 500 500"
            preserveAspectRatio="none"
            style={{ zIndex: "-2" }}
          >
            <path
              d="M0, 100 C150, 200 350, 
                0 500, 100 L500, 00 L0, 0 Z"
              style={{ stroke: "none", fill: "#1c18ee57" }}
            ></path>

            <path
              d="M0, 80 C300, 0 400,  
                300 500, 50 L500, 00 L0, 0 Z"
              style={{ stroke: "none", fill: "#1c18ee57" }}
            ></path>
            <path
              d="M0, 100 C150, 300 350, 
                0 500, 100 L500, 00 L0, 0 Z"
              style={{ stroke: "none", fill: "#183fee80" }}
            ></path>
          </svg>
        </div>
      </header> */}
    </div>
  );
};

export default IndianTaxis;
